export default __webpack_public_path__ + "static/media/inter-var-latin.45fc3e51.woff2";